import type { BoundingBox, GrayImage } from "./types";

/** Extract a rectangular sub-image from a grayscale image. */
export function cropGray(image: GrayImage, bbox: BoundingBox): GrayImage {
  const { x, y, width: w, height: h } = bbox;
  if (x < 0 || y < 0 || x + w > image.width || y + h > image.height) {
    throw new Error("crop region is out of bounds");
  }
  const data = new Uint8ClampedArray(w * h);
  for (let row = 0; row < h; row++) {
    const srcStart = (y + row) * image.width + x;
    data.set(image.data.subarray(srcStart, srcStart + w), row * w);
  }
  return { width: w, height: h, data };
}

/** Aspect ratio of a box's longer side over its shorter side (always >= 1). */
export function aspectRatio(box: BoundingBox): number {
  const long = Math.max(box.width, box.height);
  const short = Math.min(box.width, box.height);
  return short === 0 ? Infinity : long / short;
}

/** Fraction of a box's area that a component of `area` pixels fills (0..1). */
export function fillRatio(area: number, box: BoundingBox): number {
  const boxArea = box.width * box.height;
  return boxArea === 0 ? 0 : area / boxArea;
}
